'use strict'
# TODO: Refactor filename/url assignment for live preview
define [], () ->
  ($timeout, $q, User) ->
    restrict: 'AE'
    require: 'ngModel'
    link: (scope, elm, attr, model) ->
      model.$asyncValidators.usernameExists = (modelValue, viewValue) ->
        value = modelValue || viewValue
        User.check_available(username: value).$promise.then (user) ->
          if !user.available
            return $q.reject('exists')
          else
            return true




// WEBPACK FOOTER //
// ./directives/usernameAvailable/usernameAvailable.coffee